---
en:
  errors:
    invalid_number: Enter a valid number
